import { LimitedTermDuration } from '@platform-frontend/checkout-drop-in';

export type LicenseValidityGranularity = 'DATE_TIME' | 'DATE' | 'MONTH';

export type LicenseValidityDuration<T = Date> = 'UNLIMITED' | LimitedTermDuration | T;

export interface LicenseValidityContext<T = Date> {
  date: T | null;
  granularity: LicenseValidityGranularity;
  duration: LicenseValidityDuration<T> | null;
  asOfNow: boolean;
}
